import { useRef } from 'react';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import EnrollmentListFooter from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/EnrollmentListFooter';
import EnrollmentsListPanelContent from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/EnrollmentsListPanelContent';
import SelectedEnrollmentDetails from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/SelectedEnrollmentDetails';
import { parseLocation } from 'automation-ui-routing/utils';
import { useLocation } from 'react-router-dom';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { MARS_LAYER } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PANEL_WIDTH = 500;
const EnrollmentHistoryPageSidePanel = ({
  canvasTopOffset,
  isHybrid,
  flow,
  subScreen
}) => {
  const location = useLocation();
  const parsedQuery = parseLocation(location);
  const enrollmentIdFromUrl = parsedQuery.enrollmentId;
  const scrollContainer = useRef(null);
  return /*#__PURE__*/_jsx(Panel, {
    "data-test-id": "enrollment-history-container",
    width: PANEL_WIDTH,
    align: "right",
    margin: "0",
    padding: "0",
    containerZIndex: MARS_LAYER,
    position: "absolute",
    insetBlockStart: `${canvasTopOffset}px`,
    blockSize: `calc(100vh - ${canvasTopOffset}px)`,
    overflow: "visible",
    children: enrollmentIdFromUrl ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIPanelBody, {
        ref: scrollContainer,
        children: /*#__PURE__*/_jsx(SelectedEnrollmentDetails, {
          flow: flow,
          enrollmentId: Number(enrollmentIdFromUrl),
          isHybrid: isHybrid,
          scrollContainer: scrollContainer
        })
      }), /*#__PURE__*/_jsx(EnrollmentListFooter, {
        flowId: flow.flowId
      })]
    }) : /*#__PURE__*/_jsx(EnrollmentsListPanelContent, {
      flow: flow,
      isHybrid: isHybrid,
      subScreen: subScreen
    })
  });
};
export default EnrollmentHistoryPageSidePanel;